import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { $ } from "glamor";
import { theme } from "styles/theme";
import Checkbox from "material-ui/Checkbox";
import { ListItem } from "@material-ui/core";
import { Order } from "helpers/door-collection";
import { DirectionalHint, nuOrderTheme, IconButton as NuIconButton, IContextualMenuProps } from "@nuorder/components";
import CheckIcon from "@material-ui/icons/Check";
import { DimentionActionCommands } from "../dimension-types";
import { DimensionPanelDefaultAction } from "actions/tool-panel/draft/types";
import { connect } from "react-redux";
import { selectAllValues, sortAscending, sortDescending } from "actions/tool-panel/draft/actions";
import { DimensionPanelStateSelectionKind } from "reducers/dimensions-panel/dimensions-panel";

type ReduxProps = {
    selectAllValuesAction: DimensionPanelDefaultAction;
    sortAscendingAction: DimensionPanelDefaultAction;
    sortDescendingAction: DimensionPanelDefaultAction;
};

type OwnProps = {
    order: Order;
    areAllItemsSelected: boolean;
    selectionKind: Exclude<DimensionPanelStateSelectionKind, "metrics">;
    dimensionIndex: number;
};

const styles = $(" .dimensionCheckBoxAll", {
    display: "flex",
    alignItems: "center",
    width: "100%",
    borderBottom: `1px solid ${theme.palette.borderColor}`,
});

const SelectorHeader: React.FunctionComponent<OwnProps & ReduxProps> = ({
    order,
    areAllItemsSelected,
    selectionKind,
    selectAllValuesAction,
    dimensionIndex,
    sortAscendingAction,
    sortDescendingAction,
}) => {
    return (
        <ListItem {...styles}>
            <div className="dimensionCheckBoxAll">
                <Checkbox
                    className="optionsCheck"
                    checked={areAllItemsSelected}
                    value="all"
                    onCheck={() => {
                        selectAllValuesAction({ selectionKind, dimensionIndex });
                    }}
                    label={formatMessage("Select All")}
                />
            </div>
            <SortMenu
                order={order}
                onSortAscending={() => sortAscendingAction({ selectionKind, dimensionIndex })}
                onSortDescending={() => sortDescendingAction({ selectionKind, dimensionIndex })}
            />
        </ListItem>
    );
};

export const SelectorHeaderContainer = connect(null, {
    selectAllValuesAction: selectAllValues,
    sortAscendingAction: sortAscending,
    sortDescendingAction: sortDescending,
})(SelectorHeader) as unknown as React.FC<OwnProps>;

type SortMenuProps = {
    order: Order;
    onSortAscending: () => void;
    onSortDescending: () => void;
};
const SortMenu = ({ order, onSortAscending, onSortDescending }: SortMenuProps) => {
    const sortingProps: IContextualMenuProps = {
        directionalHint: DirectionalHint.leftCenter,
        gapSpace: 0,
        beakWidth: 20,
        directionalHintFixed: false,
        items: [
            {
                key: DimentionActionCommands.AscSorting,
                text: formatMessage("Ascending"),
                secondaryText:
                    order === Order.Ascending
                        ? ((<CheckIcon style={{ color: theme.palette.primary1Color }} />) as any)
                        : null,
                onClick: onSortAscending,
            },
            {
                key: DimentionActionCommands.DescSorting,
                text: formatMessage("Descending"),
                secondaryText:
                    order === Order.Descending
                        ? ((<CheckIcon style={{ color: theme.palette.primary1Color }} />) as any)
                        : null,
                onClick: onSortDescending,
            },
        ],
    };

    return (
        <NuIconButton
            role="button"
            className="item"
            aria-haspopup
            title={formatMessage("Sort by")}
            styles={{
                root: {
                    color: nuOrderTheme.palette.greyDarker,
                    height: 40,
                    selectors: {
                        " .ms-Icon": {
                            fontSize: 24,
                            color: nuOrderTheme.palette.greyDarker,
                        },
                    },
                },
            }}
            menuIconProps={{
                iconName: order === Order.Ascending ? "SortUp" : "SortDown",
            }}
            menuProps={sortingProps}
        />
    );
};
